module.exports = __webpack_public_path__ + "img/organization-description.9db1b645.svg";